module.exports = __webpack_public_path__ + "img/banner01_mo.1d457691.png";